export default {"src":"/_next/static/media/ETH.7611aeb0.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};